<template>
    <div id="app">
          <loading></loading>
          <router-view/>
    </div>
</template>
<style>
.vue-sound__player .icon-play3,.icon-pause2{
  font-size: 20px;
  color: #000!important;
}
.vue-sound__playback-time-wrapper,.vue-sound__extern-wrapper{
  display: none!important;
}

.aplayer-pic,.aplayer .aplayer-body .aplayer-info{
  height: 40px!important;
}
.aplayer-body .aplayer-info{
  padding: 0 7px 0 10px!important;
  display: none!important;;
}
#app{
  width: 100%;
  height: 100%;
}
  /* @font-face{
    font-family: 'oswald';
    src : url('../public/mp3/苹方黑体-中黑-简.ttf');
} */
    * {
        list-style: none;
        text-decoration: none;
        margin: 0;
        padding: 0;
        /* font-family: oswald!important; */
    }
    .vjs-icon-placeholder{
        font-family:VideoJS  !important
    }
    .vjs-play-progress{
        font-family:VideoJS  !important
    }
    html{
        background:#F3F4F8;
       
    }
    /*.transitionRouter-enter-active,*/
    /*.transitionRouter-leave-active {*/
        /*transition: all 0.4s;*/
    /*}*/

    /*.transitionRouter-enter,*/
    /*.transitionRouter-leave{*/
        /*transform: translateX(100%);*/
    /*}*/
    /*.el-container{*/
        /*height: 100%;*/
    /*}*/

</style>
<script type="text/javascript">
    import loading from './components/learningAbility/Loading'
    export default {
        metaInfo () {
            return {
                title: this.Pctitle,
                meta: [{                 // set meta
                    name: 'keyWords',
                    content: this.copyright.keywords,
                }],
                link: [{                 // set link
                    rel: 'icon',
                    href: this.copyright.mark
                }]
            }
        },    
        components:{ loading },
        data() {
            return {
              Pctitle:'',
              copyright:[],
              navs:[
                  {name:'登录',path:'/login'},
                  {name:'注册',path:'/register'},
                  {name:'忘记密码',path:'/forgetPassword'},
                  {name:'完善信息',path:'/perfectInformation'},
                  {name:'咨询师首页',path:'/consultant/home'},
                  {name:'消息管理',path:'/consultant/message'},
                  {name:'新的学生',path:'/consultant/newstudent/main/home',query:{studentId:3010,id:18}},
                  {name:'测评报告',path:'/consultant/newstudent/main/evaluationReport',query:{studentId:23,id:6}},
                  {name:'首次访谈',path:'/consultant/newstudent/main/firstInterview',query:{studentId:23,id:6}},
                 {name:'添加访谈A',path:'/consultant/newstudent/main/firstInterviewPartA',query:{studentId:23,id:6,show:false}},
                 {name:'添加访谈B',path:'/consultant/newstudent/main/firstInterviewPartB',query:{studentId:23,id:6,show:false}},
                 {name:'添加拆分',path:'/consultant/minestudent/main/implement/targetsplit/add'},
                 {name:'添加评估',path:'/consultant/minestudent/main/implement/assessment/add',query:{assessmentAddId:6,gradeName:'高三上学期',nameName:'第一次月考'}},
                 {name:'添加行动',path:'/consultant/minestudent/main/implement/actionplan/add',query:{gradeDetailId:6,array:0}},
                 {name:'行动评估',path:'/consultant/minestudent/main/implement/actionplan/assessmentAdd',query:{gradeDetailId:6,actionPlanId:7}}
              ]
            }
        },
        methods: {
            addLoading() {
            },

            isCloseLoading() {
            },
            // 获取版权信息
            get_footer_copyright(){
                var OEMdomain = this.$OEMdomain=='localhost'?'http://39.98.37.134':this.$OEMdomain,
                _this = this;
                this.$ajax.post(this.G_uri + '/website/getConfigInfo', {
                    webSite: OEMdomain
                }).then(function(res){
                    if(res.data.code == 2000){
                        _this.copyright = res.data.data;
                        _this.Pctitle = res.data.data.title
                    }
                })
            }, 
        },
        mounted() {
          this.get_footer_copyright();
        },
        created(){
          this.get_footer_copyright();
        }   
    }
</script>
<style lang="less" scoped>

  .navulli{
    //display: none;
    *{
      box-sizing: border-box;
    }
    position: fixed;
    width:200px;
    bottom:0;
    left: 0;
    height: 300px;
    font-size: 16px;
    z-index: 9999999999999999999999999999999999;
    opacity: 0;
    &:hover{
      opacity: 1;
    }
    li{
      width: 100px;
      height: 30px;
      line-height: 30px;
      float: left;
      text-align: center;
      cursor: pointer;
      background: #ffff;
      letter-spacing: 2px;
      border:1px solid #ddd;
      &:hover{
        background: #2D8FFC;
        color:#fff;
        font-weight: bolder;
      }
    }
    .router-link-active {
      background: #2D8FFC;
      color:#fff;
      font-weight: bolder;
    }
  }
</style>
